import React from "react";

const ControlledTableContext = React.createContext({});

export default ControlledTableContext;
